/* Copyright (c) 2022 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum VideoPlayerStates {
    /* 0 */ UNLOADED = 'UNLOADED',
    /* 1 */ LOADING = 'LOADING',
    /* 2 */ LOADED = 'LOADED',
}
